import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getLinkTokenStorage } from '@identity/composition';
import { SuccessCard } from '@identity/presentation/components/base';
import { SIGN_IN_ROUTE } from '@identity/presentation/constants';

/**
 * The last screen of the invitation flow. Activating an account creates no session, so its exit goes
 * to the login and never into the application.
 *
 * The link session is deleted on click and not on mount, and the order matters: this view appears
 * while the refetch that follows the last write is still running, and clearing the cookie earlier
 * would answer it with a `401` on a screen that already finished. Keeping the token those few
 * seconds grants nothing, because the flow is complete and the backend rejects it.
 */
export const ActivationDoneScreen = () => {
  const { t } = useTranslation('identity');
  const history = useHistory();

  const onExit = () => {
    getLinkTokenStorage().clear();
    history.push(SIGN_IN_ROUTE);
  };

  return (
    <SuccessCard
      actionLabel={t('done.action')}
      description={<Trans components={{ strong: <strong /> }} i18nKey="identity:done.body" />}
      onAction={onExit}
      title={t('done.title')}
    />
  );
};
